import { registerPlugin } from '@capacitor/core';
const BackgroundIntervalProcess = registerPlugin('BackgroundIntervalProcess');
export * from './definitions';
export { BackgroundIntervalProcess };
//# sourceMappingURL=index.js.map